import Home from "../views/home/Home.vue";
import ReportDetails from "../views/reports-details/ReportDetails.vue";

export default [
  {
    path: "/informes",
    name: "Public reports",
    component: Home,
    meta: {
      title: "Informes",
      requiresAuthentication: false,
    },
    beforeEnter: (to, from, next) => {
      localStorage.setItem("layout", "web");
      next();
    },
  },
  {
    path: "/reports/:alias",
    name: "Report",
    component: ReportDetails,
    meta: { title: "Detalles del informe", requiresAuthentication: false },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "web");
      next();
    },
  },
  {
    path: "/public/:alias",
    name: "PublicReport",
    component: ReportDetails,
    meta: { title: "Detalles del informe", requiresAuthentication: false },
    beforeEnter: (to, from, next) => {
      localStorage.setItem("layout", "web");
      next();
    },
  },
];
